<template>
  <form @submit.prevent="onsubmit">
    <va-input
      v-model="email"
      type="email"
      name="email"
      :label="$t('auth.email')"
      :error="!!emailErrors.length"
      :error-messages="emailErrors"
    />

    <!-- <div class="form-group" :class="{ 'form-group--error': $v.password.$error }">
      <label class="form__label">Password</label>
      <input class="form__input" v-model.trim="$v.password.$model"/> -->

    <va-input
      v-model="password"
      :type="showPassword ? 'text' : 'password'"
      name="password"
      autocomplete="on"
      :label="$t('auth.password')"
      :error="!!passwordErrors.length"
      :error-messages="passwordErrors"
    >
      <va-button
        slot="append"
        type="button"
        size="small"
        color="primary"
        class="password-toggle-btn"
        :aria-label="showPassword ? 'Скрыть пароль' : 'Показать пароль'"
        @click="showPassword = !showPassword"
      >
        <va-icon :name="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" />
      </va-button>
    </va-input>

    <!-- </div>
    <div class="error" v-if="!$v.password.required">Field is required</div> -->

    <div
      class="auth-layout__options d-flex align--center justify--space-between"
    >
      <va-checkbox
        v-model="keepLoggedIn"
        class="mb-0"
        :label="$t('auth.keep_logged_in')"
      />
      <!-- <router-link class="ml-1 link" :to="{name: 'recover-password'}">{{$t('auth.recover_password')}}</router-link> -->
    </div>

    <div class="d-flex justify--center mt-3">
      <va-button :disabled="getIsSubmitting" type="submit" class="my-0">{{
        $t("auth.login")
      }}</va-button>
    </div>
  </form>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      error: {
        email: "",
        password: "",
      },
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: [],
      showPassword: false,
    };
  },
  validations: {
    password: {
      required,
    },
  },
  computed: {
    // mapState
    ...mapState("auth", ["isSubmitting", "errors"]),
    getIsSubmitting() {
      return this.isSubmitting;
    },
    formReady() {
      return !this.emailErrors.length && !this.passwordErrors.length;
    },
    getErrors() {
      return this.errors;
    },
  },
  methods: {
    // mapMutation
    ...mapMutations("auth", ["LOGIN_START"]),
    ...mapActions("auth", ["login"]),
    async onsubmit() {
      this.emailErrors = this.email
        ? []
        : ["Поле Логин/Email обязательно для заполнение"];
      this.passwordErrors = this.password
        ? []
        : ["Поле пароль обязательно для заполнение"];
      try {
        if (!this.formReady) {
          return;
        }
        const data = {
          email: this.email,
          password: this.password,
        };
        await this.login(data).then((res) => {
          if (res.full_name) {
            this.$router.push({ name: "orders" });
          }
        });
      } catch (error) {
        return error;
      }
    },
  },
};
</script>

<style scoped>
.error {
  color: #df4759;
  font-weight: bold;
  font-size: 12px;
}

.password-toggle-btn {
  margin-right: 0;
  min-width: 36px;
  padding-left: 8px;
  padding-right: 8px;
}
</style>
